import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"

import Button from "@components/Button/Button"
import HeroSmall from "@components/HeroSmall/HeroSmall"
import Layout from "@components/Layout/Layout"
import { SEO } from "@components/SEO/SEO"

import ContactUs from "@components/ContactUs/contactus"

const Balcon = ({ data }) => (
  <Layout lang="fr" dropdownId="balcony">
    <HeroSmall
      title="Balkon FBlade"
      backgroundHero={data.balcon}
      alt={data.balcon.name}
    />
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <section className="pt-28">
        <div className="mt-10 flex flex-col gap-5 md:flex-row">
          <GatsbyImage
            image={getImage(data.balcon)!}
            alt={data.balcon.name}
            className="basis-3/5"
          />
          <div className="flex basis-2/5 flex-col justify-center">
            <p>
              Posé à l’avancement du chantier, après achèvement du lot
              gros-œuvre ou en rénovation, le balcon FBlade intègre la rupture
              thermique au droit du plancher, la gestion des eaux pluviales,
              l’accessibilité pour les personnes à mobilité réduite.
            </p>
            <p>
              La portée peut atteindre 2m50. Le balcon est 100% personnalisable.
            </p>
            <Button
              buttonURL="/elements-speciaux-beton/"
              buttonString="← Retour aux éléments spéciaux"
            />
          </div>
        </div>
      </section>
    </div>
    <ContactUs lang="fr" />
  </Layout>
)

export const query = graphql`
  {
    balcon: file(name: { eq: "balcon-f-blade" }) {
      name
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, quality: 100)
      }
    }
  }
`

export default Balcon

export const Head = ({ location }) => {
  return (
    <SEO
      title="Balcon en béton | FEHR Group"
      description="Le balcon en béton BFUHP Ductal® FEHR peut être équipé de tout type degarde-corps classique. Le mobilier BFUHP Ductal® sont une solution pérenne pour le maître d’ouvrage."
      pathname={location.pathname}
    />
  )
}
